export const BRAND = {
  name: "T Plus One",
  tagline: "Financial Market Education. Built for Serious Traders.",
  riskDisclosure:
    "T Plus One provides financial market education and market-related information. Trading and investing involve substantial financial risk and may result in losses. No educational material, market analysis, trade recommendation or historical performance should be interpreted as a guarantee of future results. Users should independently evaluate financial decisions and, where appropriate, seek advice from qualified professionals.",
};

export const NAV_LINKS = [
  { label: "Courses", to: "/courses", testid: "nav-link-courses" },
  { label: "EnTrade", to: "/entrade", testid: "nav-link-entrade" },
  { label: "Community", to: "/#community", testid: "nav-link-community" },
  { label: "About", to: "/about", testid: "nav-link-about" },
  { label: "FAQ", to: "/faq", testid: "nav-link-faq" },
];

export const CONTACT = {
  email: "hello@tplusone.in",
  phone: "+91 88918 79355",
  whatsapp: "918891879355",
  address: "GXC7+P6H, Golf Links Rd, Kowdiar Gardens, Kowdiar, Thiruvananthapuram, Kerala 695003",
};

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/t_plus_1/?hl=en", testid: "social-instagram" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/t-plus-one/", testid: "social-linkedin" },
  { label: "YouTube", href: "https://www.youtube.com/@TPlusOne", testid: "social-youtube" },
  { label: "X", href: "#", testid: "social-x" },
];

export const COURSES = [
  {
    slug: "tradex",
    index: "01",
    category: "Indian Markets",
    title: "TradeX",
    tagline: "A structured journey through the Indian stock market.",
    description:
      "A structured journey through the Indian stock market — from fundamentals to advanced trading concepts.",
    overview:
      "TradeX takes you from the absolute foundations of the Indian equity market to advanced trading concepts, through a deliberate, sequenced curriculum. You will learn how exchanges operate, how price is formed, how to read market structure, and how to manage risk with discipline — online or in the classroom.",
    duration: "3 Months",
    mode: "Online + Offline",
    fee: "₹25,000",
    level: "Beginner → Advanced",
    market: "Indian Stock Market",
    topics: [
      "Market Fundamentals",
      "Technical Analysis",
      "Market Structure",
      "Risk Management",
      "Trading Psychology",
      "Trading Strategies",
    ],
    whoFor: [
      "Complete beginners who want a serious, structured start in the Indian stock market.",
      "Active traders who feel their knowledge is scattered and want a system.",
      "Investors who want to understand price behaviour beyond tips and headlines.",
    ],
    curriculum: [
      { title: "Foundations", items: ["How Indian exchanges work", "Market participants & instruments", "Order types & execution basics"] },
      { title: "Technical Analysis", items: ["Chart reading & price action", "Support, resistance & trends", "Indicators with context"] },
      { title: "Market Structure", items: ["Structure mapping", "Breakouts & failures", "Multi-timeframe analysis"] },
      { title: "Risk & Psychology", items: ["Position sizing", "Risk frameworks", "Building a disciplined process"] },
    ],
  },
  {
    slug: "tradefx",
    index: "02",
    category: "Forex",
    title: "TradeFX",
    tagline: "Understand how the global currency market moves.",
    description:
      "Learn how the global foreign exchange market operates, from core concepts to advanced market analysis.",
    overview:
      "TradeFX decodes the world's largest financial market. From how currency pairs are quoted and why they move, to sessions, liquidity and structured technical analysis — the program builds a complete framework for reading the forex market with clarity, online or offline.",
    duration: "3 Months",
    mode: "Online + Offline",
    fee: "₹35,000",
    level: "Beginner → Advanced",
    market: "Forex",
    topics: [
      "Forex Fundamentals",
      "Currency Pairs",
      "Technical Analysis",
      "Market Structure",
      "Risk Management",
      "Trading Psychology",
    ],
    whoFor: [
      "Traders curious about the global currency market who want a proper foundation.",
      "Equity traders who want to expand into a 24-hour market.",
      "Anyone who wants to understand macro-driven price movement, not just patterns.",
    ],
    curriculum: [
      { title: "Forex Foundations", items: ["How the FX market operates", "Currency pairs & quotes", "Sessions, spreads & liquidity"] },
      { title: "Technical Analysis", items: ["Price action on FX charts", "Structure & trend analysis", "Key levels & confluence"] },
      { title: "Macro Context", items: ["Central banks & rates", "News & volatility", "Risk-on / risk-off behaviour"] },
      { title: "Risk & Process", items: ["Position sizing in FX", "Managing leverage responsibly", "Trading psychology"] },
    ],
  },
  {
    slug: "expertin",
    index: "03",
    category: "Advanced",
    title: "ExpertIN",
    tagline: "Deeper market mechanics for advanced traders.",
    description:
      "An advanced trading program focused on deeper market mechanics, institutional trading concepts and execution analysis.",
    overview:
      "ExpertIN is T Plus One's most advanced program. It is built for traders who already understand the basics and want to study how institutional participation shapes price — order flow, liquidity, advanced market structure and execution models — with rigorous risk management throughout.",
    duration: "3 Months",
    mode: "Online + Offline",
    fee: "₹45,000",
    level: "Advanced",
    market: "Advanced Trading",
    exclusive: true,
    topics: [
      "ICT Concepts",
      "Order Flow Analysis",
      "Advanced Market Structure",
      "Liquidity Concepts",
      "Execution Models",
      "Advanced Risk Management",
    ],
    whoFor: [
      "Experienced traders ready to study institutional-grade market mechanics.",
      "TradeX or TradeFX graduates who want to go deeper.",
      "Traders who want a structured approach to execution analysis.",
    ],
    curriculum: [
      { title: "Institutional Concepts", items: ["ICT frameworks", "Order blocks & fair value gaps", "Liquidity sweeps"] },
      { title: "Order Flow", items: ["Reading participation", "Depth & aggression", "Absorption & initiative activity"] },
      { title: "Advanced Structure", items: ["Internal vs external structure", "Premium & discount", "Multi-market context"] },
      { title: "Execution & Risk", items: ["Execution models", "Scenario planning", "Advanced risk management"] },
    ],
  },
];

export const COMPARISON_ROWS = [
  { label: "Market Focus", values: ["Indian Stock Market", "Forex", "Advanced Trading"] },
  { label: "Learning Level", values: ["Beginner → Advanced", "Beginner → Advanced", "Advanced"] },
  { label: "Duration", values: ["3 Months", "3 Months", "3 Months"] },
  { label: "Learning Mode", values: ["Online + Offline", "Online + Offline", "Online + Offline"] },
  { label: "Premium Community Access", values: ["Lifetime", "Lifetime", "Lifetime"] },
  { label: "Course Fee", values: ["₹25,000", "₹35,000", "₹45,000"] },
];

export const COMMUNITY_FEATURES = [
  { title: "Indian Market Insights", text: "Ongoing structured commentary on Indian equities and index behaviour." },
  { title: "Forex Market Insights", text: "Coverage of major currency pairs, sessions and macro-driven moves." },
  { title: "Trade Setups & Recommendations", text: "Educational trade setups shared with context, levels and reasoning." },
  { title: "Market Discussions", text: "A serious community of traders discussing structure, not noise." },
  { title: "Ongoing Learning", text: "Continued education long after the classroom program ends." },
  { title: "Community Access", text: "Stay connected with mentors and fellow students of T Plus One." },
];

// Set enabled to false if supporting records are not available.
export const ACCURACY = {
  enabled: true,
  label: "Historical recommendation accuracy*",
  value: "Up to 90%",
  disclosure:
    "Based on T Plus One's internally tracked historical recommendations for the applicable measurement period. Past performance and historical accuracy do not guarantee future results. Trading involves financial risk.",
};

export const PLANS = [
  {
    id: "3m",
    name: "3 Months",
    price: "₹1,998",
    period: "3 Months Access",
    features: ["Premium Community", "Indian Market Recommendations", "Forex Market Recommendations", "Market Insights", "Online Access"],
    cta: "Choose 3 Months",
  },
  {
    id: "1y",
    name: "1 Year",
    price: "₹9,999",
    period: "12 Months Access",
    note: "Popular long-term option",
    features: ["Premium Community", "Indian Market Recommendations", "Forex Market Recommendations", "Market Insights", "Online Access"],
    cta: "Choose 1 Year",
  },
  {
    id: "lifetime",
    name: "Lifetime",
    price: "₹19,999",
    period: "Lifetime Access",
    features: ["Lifetime Premium Community Access", "Indian Market Recommendations", "Forex Market Recommendations", "Market Insights", "Online Access"],
    cta: "Get Lifetime Access",
    dark: true,
  },
];

export const ENTRADE_DASHBOARD = [
  { label: "Market Updates", value: "Daily briefs" },
  { label: "Indian Market Insights", value: "NIFTY · BANKNIFTY · Equities" },
  { label: "Forex Insights", value: "Majors · Sessions · Macro" },
  { label: "Community Discussions", value: "Members only" },
  { label: "Trade Setups", value: "With context & levels" },
  { label: "Market Notes", value: "Structured commentary" },
];

export const LEARN_VS_ACCESS = {
  courses: {
    title: "Courses",
    audience: "Designed for people who want structured financial market education.",
    items: ["3-month structured learning", "Online + Offline learning", "Market education", "Lifetime Premium Community access"],
  },
  entrade: {
    title: "EnTrade",
    audience: "Designed for people who primarily want digital access to the Premium Community.",
    items: ["Online membership", "Market insights", "Trade recommendations", "Community access"],
  },
};

export const JOURNEY = [
  { n: "01", title: "Learn", text: "Build strong foundations." },
  { n: "02", title: "Understand", text: "Study how markets behave." },
  { n: "03", title: "Analyse", text: "Apply structured frameworks to real market conditions." },
  { n: "04", title: "Practice", text: "Develop disciplined execution and risk management." },
  { n: "05", title: "Stay Connected", text: "Continue learning through the Premium Community." },
];

export const WHY_ITEMS = [
  { title: "Structured, not scattered.", text: "Financial education should follow a system, not random social-media content." },
  { title: "Fundamentals before complexity.", text: "Advanced concepts mean little without understanding the basics." },
  { title: "Education beyond the classroom.", text: "Course students continue to receive lifetime access to the Premium Community." },
  { title: "Multiple markets. One ecosystem.", text: "Indian equities, Forex and advanced trading concepts within one learning platform." },
];

export const TESTIMONIALS = [
  { name: "Afzal Muhammed S", course: "Verified Student", quote: "Firstly it's a 100% genuine trustworthy course. They are providing budget friendly trading course package. The best part is the access to the large trading community of T plus one. We can easily study trading strategies very fast. Live trading sessions also included in syllabus. Friendly, helpful and trustable mentor. Highly recommended. 👍🏻❤️‍🔥" },
  { name: "Jenish Thimothy", course: "Verified Student", quote: "This is definitely a suitable institution for a beginner trader. They provide a budget-friendly trading course package. The best part is the access to the large trading community of T Plus One. We can easily study trading strategies very quickly. Live trading sessions are also included in the syllabus. The mentor is friendly, helpful, and trustworthy." },
  { name: "Vishnu V", course: "Verified Student", quote: "I've had a very positive experience with T Plus One. Their trading service is smooth and easy to use, and the market research they provide is both accurate and insightful. The team is professional, responsive, and always willing to guide whenever needed. I truly appreciate their transparency and reliability, which makes trading much more confident and stress-free. Highly recommended for anyone interested in the stock market and also crypto, forex." },
  { name: "Vinod Natesan", course: "Verified Student", quote: "Before joining here, I faced continuous losses as I was not fully aware of how the market works. After joining this institution, the way Sooraj sir teaches each concept in detail has been a true turning point in my trading journey. His strategies not only gave me confidence to trade without fear but also helped me recover my past losses and start making consistent profits. I sincerely thank Suraj sir for guiding us on the right path and making trading a skill that feels structured and achievable. Highly recommend this institution and Suraj sir's mentorship to anyone who wants to trade with confidence and clarity. 🙏" },
];

// PLACEHOLDER DATA — replace with verifiable figures before production.
export const STATS = [
  { label: "Students Educated", value: "55,000+", placeholder: false },
  { label: "Years of Market Education", value: "4+", placeholder: false },
  { label: "Community Members", value: "55,000+", placeholder: false },
  { label: "Courses", value: "3", placeholder: false },
];

export const FAQS = [
  { category: "General", q: "What is T Plus One?", a: "T Plus One is a financial-market education company. We provide structured courses on the Indian stock market, Forex and advanced trading concepts, along with EnTrade — a digital membership that gives ongoing access to our Premium Community." },
  { category: "Courses", q: "Who are the courses designed for?", a: "TradeX and TradeFX are designed for beginners through to advancing traders who want a structured learning path. ExpertIN is designed for experienced traders who want to study advanced, institutional-grade market mechanics." },
  { category: "Courses", q: "Can beginners join TradeX?", a: "Yes. TradeX starts from market fundamentals and progresses to advanced concepts in a deliberate sequence, so no prior trading experience is required." },
  { category: "Courses", q: "Do I need prior Forex knowledge for TradeFX?", a: "No. TradeFX begins with how the foreign exchange market operates — currency pairs, sessions and quotes — before moving into technical analysis and market structure." },
  { category: "Courses", q: "Who should choose ExpertIN?", a: "ExpertIN is for traders who already understand market basics and want to study ICT concepts, order flow, liquidity and execution models. It is our most advanced program." },
  { category: "Courses", q: "Are courses available online?", a: "Yes. TradeX, TradeFX and ExpertIN are all available online, with live sessions, structured materials and community support." },
  { category: "Courses", q: "Are courses available offline?", a: "Yes. All three courses are also offered in a classroom format for students who prefer direct, in-person interaction." },
  { category: "Courses", q: "How long are the courses?", a: "Each course — TradeX, TradeFX and ExpertIN — runs for 3 months." },
  { category: "EnTrade", q: "What is EnTrade Membership?", a: "EnTrade is T Plus One's completely online membership. It gives you access to the Premium Community, Indian and Forex market insights, educational trade recommendations and market notes — without enrolling in a full course." },
  { category: "EnTrade", q: "Is EnTrade completely online?", a: "Yes. EnTrade is a digital-only product. Everything — community, insights and recommendations — is delivered online." },
  { category: "EnTrade", q: "Do course students receive Premium Community access?", a: "Yes. Students who enrol in TradeX, TradeFX or ExpertIN receive access to the T Plus One Premium Community." },
  { category: "EnTrade", q: "How long does Premium Community access last for course students?", a: "Lifetime. Course students keep their Premium Community access even after their program ends." },
  { category: "Risk", q: "Does T Plus One guarantee profits?", a: "No. T Plus One is an education company. We teach market concepts, structure and risk management — we do not guarantee profits or returns of any kind. Trading involves substantial financial risk." },
  { category: "Risk", q: "Are trade recommendations guaranteed to be profitable?", a: "No. Trade recommendations shared in the Premium Community are educational in nature. Historical accuracy, where quoted, reflects internally tracked past performance and does not guarantee future results. Always evaluate financial decisions independently." },
];

export const FAQ_CATEGORIES = ["General", "Courses", "EnTrade", "Risk"];

const LEGAL_NOTE = "Template wording — to be reviewed and replaced with final regulatory text before production deployment.";

export const LEGAL_PAGES = {
  terms: {
    title: "Terms & Conditions",
    note: LEGAL_NOTE,
    sections: [
      { heading: "1. Nature of Services", body: "T Plus One provides financial market education through online and offline courses (TradeX, TradeFX, ExpertIN) and a digital membership product (EnTrade). All content is educational and informational in nature and does not constitute investment advice, portfolio management or a solicitation to buy or sell any security or instrument." },
      { heading: "2. Enrolment & Access", body: "Course enrolment is confirmed upon receipt of the applicable course fee. EnTrade membership access is granted for the duration of the selected plan (3 months, 1 year or lifetime). Access is personal to the enrolled student or member and may not be shared or transferred." },
      { heading: "3. Intellectual Property", body: "All course materials, community content, market notes and recommendations are the intellectual property of T Plus One and are provided for personal educational use only. Redistribution, recording or resale is prohibited." },
      { heading: "4. Limitation of Liability", body: "T Plus One is not liable for any financial loss arising from trading or investment decisions made by students or members. Trading and investing involve substantial risk, and users act entirely at their own discretion and risk." },
      { heading: "5. Changes to Terms", body: "T Plus One may update these terms from time to time. Continued use of the services after changes are published constitutes acceptance of the revised terms." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    note: LEGAL_NOTE,
    sections: [
      { heading: "1. Information We Collect", body: "We collect information you provide directly — such as your name, email address, phone number and enquiry details — when you contact us, enrol in a course or join EnTrade." },
      { heading: "2. How We Use Information", body: "Your information is used to respond to enquiries, process enrolments, deliver course and membership services, and communicate relevant educational updates. We do not sell your personal data." },
      { heading: "3. Data Security", body: "We apply reasonable technical and organisational measures to protect your information. However, no method of transmission over the internet is completely secure." },
      { heading: "4. Your Rights", body: "You may request access to, correction of, or deletion of your personal data by contacting us. We will respond to verified requests within a reasonable timeframe." },
      { heading: "5. Contact", body: "For privacy-related questions, contact T Plus One through the details on our contact page." },
    ],
  },
  refund: {
    title: "Refund Policy",
    note: LEGAL_NOTE,
    sections: [
      { heading: "1. Course Fees", body: "Course fees for TradeX, TradeFX and ExpertIN are charged per 3-month program. Refund eligibility, timelines and any applicable deductions will be communicated at the time of enrolment. Once a batch has commenced, fees may be non-refundable except as required by law." },
      { heading: "2. EnTrade Membership", body: "EnTrade membership fees (3 months, 1 year, lifetime) are charged for digital access. Refunds, if any, are handled on a case-by-case basis. Please contact us before purchasing if you have questions about plan suitability." },
      { heading: "3. Batch Transfers", body: "Where a student cannot continue with a scheduled batch, T Plus One may, at its discretion, offer a transfer to a subsequent batch instead of a refund." },
      { heading: "4. How to Request", body: "To request a refund or batch transfer, contact us through the contact page with your enrolment details. Requests are typically reviewed within 7–10 business days." },
    ],
  },
  "risk-disclosure": {
    title: "Risk Disclosure",
    note: LEGAL_NOTE,
    sections: [
      { heading: "Educational Purpose Only", body: "T Plus One provides financial market education and market-related information. Nothing on this website, in our courses, or within the Premium Community constitutes investment advice, research recommendations or a solicitation to transact in any security, derivative or currency." },
      { heading: "Trading Risk", body: "Trading and investing involve substantial financial risk and may result in losses, including losses exceeding your initial capital in leveraged products such as derivatives and forex. You should never trade with money you cannot afford to lose." },
      { heading: "No Guarantee of Results", body: "No educational material, market analysis, trade recommendation or historical performance — including any historically tracked accuracy figures — should be interpreted as a guarantee of future results. Past performance does not assure future outcomes." },
      { heading: "Independent Evaluation", body: "Users should independently evaluate all financial decisions and, where appropriate, seek advice from qualified professionals, including SEBI-registered investment advisers, before acting on any market information." },
    ],
  },
};

export const INTEREST_OPTIONS = [
  "TradeX — Indian Markets",
  "TradeFX — Forex",
  "ExpertIN — Advanced",
  "EnTrade — 3 Months",
  "EnTrade — 1 Year",
  "EnTrade — Lifetime",
  "General Enquiry",
];
